import { serviceAPI } from './api';

export type ChecklistType = 'pre_service' | 'post_service';

export interface ChecklistItemResponse {
  item: string;
  completed: boolean;
  notes?: string;
}

export interface ServiceChecklistResponse {
  id: string;
  appointment_id: string;
  employee_id: string;
  employee_name?: string;
  type: ChecklistType;
  template_name?: string;
  responses: ChecklistItemResponse[] | string;
  notes?: string;
  client_signature?: string;
  client_signed_at?: string;
  created_at?: string;
}

export const getChecklistResponsesByAppointment = async (
  appointmentId: string,
): Promise<ServiceChecklistResponse[]> => {
  const { data } = await serviceAPI.get<ServiceChecklistResponse[]>(
    `/checklist/responses/appointment/${appointmentId}`,
  );
  return Array.isArray(data) ? data : [];
};

